import StartFlow from "./NodeContents/StartFlow.tsx";
import TextButton from "./NodeContents/TextButtons.tsx";
import MediaButton from "./NodeContents/MediaButton.tsx";
import CateglougeMessage from "./NodeContents/CatelougMessage.tsx";
import SingleProduct from "./NodeContents/SingleProduct.tsx";
import List from "./NodeContents/List.tsx";
import RequestInterventation from "./NodeContents/RequestIntervension.tsx";
import ConversionAPI from "./NodeContents/ConversionAPI.tsx";
import MultiProduct from "./NodeContents/MultiProduct.tsx";
import ProductList from "./NodeContents/ProductList.tsx";
import Template from "./NodeContents/Template.tsx";
import Location from "./NodeContents/Location.tsx";
import Question from "./NodeContents/Question.tsx";
import Tag from "./NodeContents/Tag.tsx";
import Condition from "./NodeContents/Condition.tsx";
import AskMedia from "./NodeContents/AskMedia.tsx";
import Attribute from "./NodeContents/Attribute.tsx";
import ConnectFlow from "./NodeContents/ConnectFlow.tsx";
import APIRequest from "./NodeContents/ApiRequest.tsx";
import AskAddress from "./NodeContents/AskAddress.tsx";
import Carousel from "./NodeContents/Carousel.tsx";
import SmartDelay from "./NodeContents/SmartDelay.tsx";
import GoogleSheets from "./NodeContents/GoogleSheets.tsx";

const NodeContent = ({ nodeContent, type, openDialog, nodeId, subNodeId, parentId, selectedMedia, onMediaTypeChange }) => {
  switch (type) {
    case "FLOW_START":
      return <StartFlow nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />;
    case "TEXT_BUTTON":
      return <TextButton nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />;
    case "MEDIA_BUTTON":
      return <MediaButton nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} openDialog={openDialog} selectedMedia={selectedMedia} onMediaTypeChange={onMediaTypeChange} />;
    case "LIST":
      return <List nodeId={nodeId} subNodeId={subNodeId} />;
    case "CATELOGUE_MESSAGE":
      return <CateglougeMessage nodeId={nodeId} subNodeId={subNodeId} />;
    case "SINGLE_PRODUCT":
      return <SingleProduct parentId={parentId} nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />;
    case "MULTI_PRODUCT":
      return <MultiProduct parentId={parentId} nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />;
    case "PRODUCT_LIST":
      return <ProductList parentId={parentId} nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />;
    case "LOCATION":
      return <Location nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />
    case "TEMPLATE":
      return <Template nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />;
    case "QUESTION":
      return <Question nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />;
    case "INTERVENTION":
      return <RequestInterventation nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />;
    case "CONVERSION":
      return <ConversionAPI />;
    case "ADD_TAG":
      return <Tag nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />
    case "ATTRIBUTE":
      return <Attribute nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />
    case "MEDIA":
      return <AskMedia nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />
    case "FLOW":
      return <ConnectFlow nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />
    case "CONDITION":
      return <Condition parentId={parentId} nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />
    case "API_REQUEST":
      return <APIRequest parentId={parentId} nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />
    case "ADDRESS":
      return <AskAddress parentId={parentId} nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />
    case "CAROUSEL":
      return <Carousel nodeId={nodeId} subNodeId={subNodeId} />
    case "SMART_DELAY":
      return <SmartDelay nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />
    case "GOOGLE_SHEETS":
      return <GoogleSheets nodeId={nodeId} subNodeId={subNodeId} nodeContent={nodeContent} />
    default:
      return null;
  }
}

export default NodeContent;

